export const POSITION_REPORT = "POSITION_REPORT";
export const POSITION_ERROR = "POSITION_ERROR";
export const POSITION_ERROR_HIDE = "POSTION_ERROR_HIDE";
export const POSITION_EMPTY_VALIDATION = "POSITION_EMPTY_VALIDATION";
export const POSITION_HIDE_EMPTY_VALIDATION = "POSITION_HIDE_EMPTY_VALIDATION";
